export default "__VITE_ASSET__bKVDmsWe__"